import { useQuery, UseQueryResult } from 'react-query';
import { IdempotencyKeys } from '../../services/IdempotencyKeys';
import { CLIENT_LEAD_IDEMPOTENCY_KEY } from '../../constants/reactQuery.keys';

export const useIdempotencyKey = (eventId?: string): UseQueryResult<string | null> =>
  useQuery<string | null>({
    queryKey: [CLIENT_LEAD_IDEMPOTENCY_KEY],
    queryFn: (): Promise<string | null> => IdempotencyKeys.getIdempotencyKey(eventId),
  });
